import React, { useEffect, useState } from 'react';
import { PiDesktop, PiDotsNine, PiList, PiMoon, PiSun } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import AccountPageHeader from '../../../components/AccountPageHeader';
import PageIntro from '../../../components/PageIntro';
import { useTheme } from '../../../ThemeContext';
import {
  MOBILE_NAVIGATION_STYLES,
  useMobileNavigationStyle,
} from '../../../hooks/useMobileNavigationStyle';
import '../../../styles/account-pages.css';

const DESKTOP_QUERY = '(min-width: 1180px)';

const Appearance = () => {
  const navigate = useNavigate();
  const { theme, setTheme } = useTheme();
  const [navigationStyle, setNavigationStyle] = useMobileNavigationStyle();

  const [desktop, setDesktop] = useState(() => window.matchMedia(DESKTOP_QUERY).matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia(DESKTOP_QUERY);
    const handleChange = (event) => setDesktop(event.matches);
    setDesktop(mediaQuery.matches);
    mediaQuery.addEventListener?.('change', handleChange);
    return () => mediaQuery.removeEventListener?.('change', handleChange);
  }, []);

  const themeOptions = [
    { value: 'system', label: 'Sistema', description: 'Acompanhar a preferência do dispositivo', icon: <PiDesktop size={22} /> },
    { value: 'light', label: 'Claro', description: 'Sempre usar o tema claro', icon: <PiSun size={22} /> },
    { value: 'dark', label: 'Escuro', description: 'Sempre usar o tema escuro', icon: <PiMoon size={22} /> },
  ];

  const navigationOptions = [
    {
      value: MOBILE_NAVIGATION_STYLES.PILL,
      label: 'Flutuante',
      description: 'Menu compacto que fica destacado sobre a tela.',
      icon: <PiDotsNine size={22} />,
    },
    {
      value: MOBILE_NAVIGATION_STYLES.STANDARD,
      label: 'Barra inferior',
      description: 'Menu fixo ocupando a parte inferior da tela.',
      icon: <PiList size={22} />,
    },
  ];

  return (
    <div className="account-page">
      <AccountPageHeader title="Aparência" onBack={() => navigate(-1)} />
      <main className="account-content">
        <PageIntro description="Escolha como a Nara deve aparecer neste dispositivo." />
        <section className="account-section" aria-labelledby="appearance-title">
          <div className="account-section__heading">
            <h2 id="appearance-title">Preferências visuais</h2>
          </div>

          <div className="setting-choice-group">
            <h3>Tema do aplicativo</h3>
            <div className="theme-options" role="radiogroup" aria-label="Tema do aplicativo">
              {themeOptions.map((option) => (
                <label className={'theme-option ' + (theme === option.value ? 'theme-option--selected' : '')} key={option.value}>
                  <input type="radio" name="theme" value={option.value} checked={theme === option.value} onChange={() => setTheme(option.value)} />
                  <span className="theme-option__icon" aria-hidden="true">{option.icon}</span>
                  <span className="theme-option__content"><strong>{option.label}</strong><small>{option.description}</small></span>
                </label>
              ))}
            </div>
          </div>

          {!desktop && (
            <div className="setting-choice-group">
              <h3>Navegação</h3>
              <p>Escolha como o menu inferior aparece no dispositivo.</p>
              <div className="setting-choice-list" role="radiogroup" aria-label="Navegação">
                {navigationOptions.map((option) => (
                  <label className={'setting-choice setting-choice--with-icon ' + (navigationStyle === option.value ? 'setting-choice--selected' : '')} key={option.value}>
                    <input
                      type="radio"
                      name="mobile-navigation"
                      value={option.value}
                      checked={navigationStyle === option.value}
                      onChange={() => setNavigationStyle(option.value)}
                    />
                    <span className="setting-choice__icon" aria-hidden="true">{option.icon}</span>
                    <span>
                      <strong>{option.label}</strong>
                      <small>{option.description}</small>
                    </span>
                  </label>
                ))}
              </div>
            </div>
          )}

        </section>
      </main>
    </div>
  );
};

export default Appearance;
